import {NgModule} from '@angular/core';
import {NoPreloading, RouterModule, Routes} from '@angular/router';
import {HomeComponent} from 'projects//paid_ukr/src/app/routes/home/home.component';
import {
    TermsAndConditionsComponent
} from 'projects//paid_ukr/src/app/routes/terms-and-conditions/terms-and-conditions.component';
import {ConfirmSignInComponent} from 'projects//paid_ukr/src/app/components/auth/confirm-sign-in/confirm-sign-in.component';
import {GetHelpComponent} from './components/get-help/get-help.component';
import {AboutPageComponent} from './components/about-page/about-page.component';
import {UnsubscribeComponent} from './routes/unsubscribe/unsubscribe.component';
import {AfterPaymentComponent} from './components/after-payment/after-payment.component';
import {TestComponent} from './components/test/test.component';
import {ReportComponent} from './routes/report/report.component';
import {ProgressComponent} from './routes/progress/progress.component';
import {DashboardComponent} from './components/dashboard/dashboard.component';
import {PatientDashboardComponent} from './components/dashboard/patient-dashboard/patient-dashboard.component';
import {NewClientSessionComponent} from './components/dashboard/new-client-session/new-client-session.component';
import {ForBusinessComponent} from './routes/for-business/for-business.component';

const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
        data: {
            showStart: true,
            showContactForDemo: false
        }
    },
    {
        path: 'for-business',
        component: ForBusinessComponent,
        data: {
            showStart: false,
            showContactForDemo: true
        }
    },
    {
        path: 'terms-and-conditions',
        component: TermsAndConditionsComponent
    },
    // {
    //     path: 'progress',
    //     component: ProgressComponent
    // },
    {
        path: 'test',
        component: TestComponent
    },
    {
        path: 'about-us',
        component: AboutPageComponent,
        data: {
            showStart: true,
            showContactForDemo: false
        }
    },
    {
        path: 'unsubscribe',
        component: UnsubscribeComponent
    },
    {
        path: 'get-help',
        component: GetHelpComponent
    },
    {
        path: 'notice-of-privacy-practices',
        component: HomeComponent
    },
    {
        path: 'notice-of-nondiscrimination',
        component: HomeComponent
    },
    {
        path: 'login',
        component: ConfirmSignInComponent
    },
    {
        path: 'ap',
        component: AfterPaymentComponent
    },
    {
        path: 'cs',
        loadChildren: () => import('./routes/select-test/select-test.module').then(m => m.SelectTestModule)
    },
    {
        path: 's',
        loadChildren: () => import('./routes/session/session.module').then(m => m.SessionModule)
    },
    {
        path: 'dashboard',
        component: DashboardComponent,
    },
    {
        path: 'dashboard/new-client-session',
        component: NewClientSessionComponent,
        pathMatch: 'full'
    },
    {
        path: 'dashboard/:id',
        component: PatientDashboardComponent
    },
    {
        path: 'articles',
        component: HomeComponent,
    },
    {
        path: 'articles/:id',
        component: HomeComponent,
    },
    {
        path: 'report',
        component: ReportComponent
    },
    {
        path: '404', pathMatch: 'full',
        component: HomeComponent
    },
    {
        path: '**', pathMatch: 'full',
        component: HomeComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        useHash: false,
        scrollPositionRestoration: 'enabled',
        onSameUrlNavigation: 'reload',
        anchorScrolling: 'enabled',
        scrollOffset: [80, 80],
        preloadingStrategy: NoPreloading
    })],
    exports: [RouterModule]
})
export class AppRoutingModule {
    constructor() {
        // workaround to wait for dynamically created fragment targets
        // setTimeout(() => {
        //     router.navigate([], {               // navigate to the same / current url
        //         preserveFragment: true,     // fragment to navigate
        //         skipLocationChange: true  // prevent history pollution
        //     });
        // }, 200);
    }
}
